import React from 'react'
import { AnnotationDetailModel } from '../requestsModel'
import SvgAttachment from '../../../icons/Attachment'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { useMediaQuery } from 'react-responsive'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import fetchFactory from '../../../utils/fetchFactory'
import { configEnum, types } from '../../../enums/fetchFactoryEnum'
import { useDispatch } from 'react-redux'
import { displaySnackbar } from '../../reducers/snackBar/actions'
import { useIntl } from 'react-intl'

const UNNAMED_FILE = 'Unnamed'
const GET_FILE_ERROR = 'requests.detail.errorPreviewAnnotation'

const useStyles = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            alignItems: {
                verticalAlign: 'middle'
            },
            alignItemsLargeScreen: {
                '&:first-child': {
                    marginRight: 20
                }
            },
            alignItemsSmallScreen: {
                '&:first-child': {
                    marginRight: 10
                }
            },
            fileContainerStyle: {
                padding: '12px 12px 12px 16px',
                marginTop: 20,

                '& svg': {
                    marginLeft: 'auto'
                }
            },
            bgColorWhite: {
                background: 'white'
            },
            bgColorGrey: {
                background: theme.palette.blue['5'],
            }
        }
    )
)

interface Store {
    annotation: AnnotationDetailModel,
    whiteMode?: boolean
}

type AnnotationItemProps = Store

const AnnotationItem: React.FC<AnnotationItemProps> = (
    {
        annotation,
        whiteMode = false
    }
) => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const intl = useIntl()
    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )

    const fileContainerClass: ClassValue = classNames(
        'col-xs-12',
        classes.fileContainerStyle,
        whiteMode ? classes.bgColorWhite : classes.bgColorGrey,
        classes.flex,
        classes.alignCenter
    )

    const fileNameClass: ClassValue = classNames(
        classes.colorBlue,
        classes.alignItems,
        classes.cursorPointer,
        {
            [classes.alignItemsLargeScreen]: isLargeScreen,
            [classes.text2]: isLargeScreen,
            [classes.alignItemsSmallScreen]: !isLargeScreen,
            [classes.text3_opacity]: !isLargeScreen
        }
    )

    const fileIconClass: ClassValue = classNames(
        classes.colorAccessibility,
        classes.alignItems,
        classes.cursorPointer,
        isLargeScreen ? classes.alignItemsLargeScreen : classes.alignItemsSmallScreen
    )

    const downloadFile = () => {
        fetchFactory(
            `/api/ec_${process.env.REACT_APP_TARGET}/demande/getDocuments?annotationId=${annotation.id}&echangeId=${annotation.echange_id}`,
            { method: configEnum.get },
            types.blob
        ).then(
            (blob: any) => {
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = annotation.filename || UNNAMED_FILE
                a.click()
            }
        ).catch(
            (error) => {
                console.log('error', error)
                dispatch(displaySnackbar(
                    {
                        id: GET_FILE_ERROR,
                        message: intl.formatMessage(
                            {
                                id: GET_FILE_ERROR,
                                defaultMessage: 'La pièce jointe n\'existe pas',
                                description: 'Erreur fichier'
                            }
                        ),
                        open: true,
                        hideIcon: true
                    }
                ))
            }
        )
    }

    return <div
        className={fileContainerClass}
    >
        <div className={fileIconClass}>
            <SvgAttachment color="#122941" />
        </div>

        <span className={fileNameClass} onClick={downloadFile}>
        {annotation.filename || UNNAMED_FILE}
      </span>
    </div>
}

export default AnnotationItem
